import type { User, UserAssignSelectUserFragment } from '@/generated/graphql';

export type PinnedUserPositions = Map<User['id'], UserAssignSelectRole>;

export enum RoleSlotType {
	Role = 'role',
	PinnedUser = 'pinnedUser',
}

export type RoleSlotItem =
	| { type: RoleSlotType.Role; id: string; role: UserAssignSelectRole }
	| {
			type: RoleSlotType.PinnedUser;
			id: string;
			user: UserAssignSelectUserFragment;
			replacedRole: UserAssignSelectRole;
	  };

export enum UserAssignGroups {
	All = 'all-users',
	ProjectMembers = 'project-members',
	Other = 'other-users',
	Cupo = 'cupo-users',
}

export type UserAssignSelectRole = {
	id: string;
	name: string;
	hslColor?: string | null;
	initials?: string | null;
};

export type UserAssignGroup = {
	id: UserAssignGroups | string;
	name: string;
	userList: UserAssignSelectUserFragment[];
	isAllUsersSelected: boolean;
	role?: UserAssignSelectRole | null;
	isRoleSelectable?: boolean;
	isUnassigned?: boolean;
};

export const UNASSIGNED_USER_ID = '0';

export type UserAssignAvatarSize = 'xx-small' | 'x-small' | 'medium';

/**
 * Payload emitted when assignees are updated in UserAssignSelect
 * @property users - Selected user fragments
 * @property hasCupoUsers - Whether any Customer Portal users are included
 * @property shouldNotify - Whether to send notifications to assigned users
 * @property roles - Optional role assignments for the users
 */
export type UserAssignSelectAssigneesPayload = {
	users: UserAssignSelectUserFragment[];
	hasCupoUsers: boolean;
	shouldNotify: boolean;
	roles?: UserAssignSelectRole[];
};
